<script setup>
import { useUISettings } from 'dashboard/composables/useUISettings';
import AccordionItem from 'dashboard/components/Accordion/AccordionItem.vue';
import ConversationDealsPanel from 'dashboard/wasapi/crm/components/ConversationDealsPanel.vue';
import ScheduledMessagesPanel from 'dashboard/wasapi/scheduled-messages/ScheduledMessagesPanel.vue';
import ConversationAppointmentPanel from 'dashboard/wasapi/appointments/components/ConversationAppointmentPanel.vue';

defineProps({
  contact: { type: Object, default: () => ({}) },
  conversationId: { type: [Number, String], default: null },
  inboxId: { type: [Number, String], default: null },
});

const { uiSettings, updateUISettings } = useUISettings();

const isOpen = key => !uiSettings.value[`is_wasapi_${key}_closed`];
const toggle = key =>
  updateUISettings({
    [`is_wasapi_${key}_closed`]: !uiSettings.value[`is_wasapi_${key}_closed`],
  });
</script>

<template>
  <div class="flex flex-col gap-3 px-2 pb-3">
    <AccordionItem
      :title="$t('WASAPI_CRM.PANEL.TITLE')"
      :is-open="isOpen('deals')"
      @toggle="toggle('deals')"
    >
      <ConversationDealsPanel
        :contact-id="contact.id"
        :contact-name="contact.name"
        :conversation-id="conversationId"
      />
    </AccordionItem>
    <AccordionItem
      :title="$t('WASAPI_APPOINTMENTS.PANEL.TITLE')"
      :is-open="isOpen('appointments')"
      @toggle="toggle('appointments')"
    >
      <ConversationAppointmentPanel
        v-if="conversationId"
        :contact="contact"
        :conversation-id="conversationId"
      />
    </AccordionItem>
    <AccordionItem
      :title="$t('WASAPI_SCHEDULED.PANEL_TITLE')"
      :is-open="isOpen('scheduled')"
      @toggle="toggle('scheduled')"
    >
      <ScheduledMessagesPanel
        v-if="conversationId"
        :conversation-id="conversationId"
        :inbox-id="inboxId"
      />
    </AccordionItem>
  </div>
</template>
